import tw, { styled } from 'twin.macro';

const HeadingResult = styled.h2<{ fontSize?: string }>`
  ${tw`mb-3 md:mb-5 relative text-center mt-16 print:!text-lg print:text-left print:mt-2 z-[4]`};
  ${(props) => (props.fontSize === 'lg' ? tw`text-2xl sm:text-4xl` : tw`text-2xl sm:text-4xl lg:text-5xl`)};
  line-height: 1.3;
`;

export default HeadingResult;
